export default __webpack_public_path__ + "static/media/Pretendard-Regular.6090e6b5.woff2";